import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDBmrX00Df45sivlbk0MdC_XHvT08kwj9k",
  authDomain: "stylesync-4d5cb.firebaseapp.com",
  databaseURL: "https://stylesync-4d5cb-default-rtdb.firebaseio.com",
  projectId: "stylesync-4d5cb",
  storageBucket: "stylesync-4d5cb.firebasestorage.app",
  messagingSenderId: "184527970219",
  appId: "1:184527970219:web:9dfdaccf936e72d58cfcee",
  measurementId: "G-MYEKVKJ9KN"
};
console.log('Firebase config:', firebaseConfig);
// --- DEBUGGING STEP ---
console.log("Firebase API Key:", process.env.REACT_APP_FIREBASE_API_KEY);
// --- END DEBUGGING STEP ---

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Isolate auth to the current tab/window to avoid cross-tab login/logout propagation
setPersistence(auth, browserSessionPersistence).catch(() => {});
export const analytics = getAnalytics(app);
export const database = getDatabase(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

export default app; 